const FUNDING_DEBIT = 'debit';
const COUNTRY_BRAZIL = 'BR';
const LANGUAGE_PT = 'pt';

export type BrazilDebitCard = {
  funding?: string;
  country?: string | null;
} | undefined;

/**
 * Stripe Brazil accounts reject LOCAL (BR-issued) debit cards only —
 * internationally issued debit is accepted.
 * https://support.stripe.com/questions/accepted-payment-methods-in-brazil
 *
 * Deliberately fail-open on an unresolved issuing country: pre-rejecting a
 * valid international debit card is worse than letting Stripe decline a BR
 * one with a generic message.
 *
 * Works against both the Stripe v2 token response card and the v3
 * `Token['card']` shapes.
 */
export function isBlockedBrazilDebit(
  card: BrazilDebitCard,
  restaurantLanguage: string | undefined,
): boolean {
  return (
    card?.funding === FUNDING_DEBIT &&
    card?.country === COUNTRY_BRAZIL &&
    restaurantLanguage === LANGUAGE_PT
  );
}
